module.exports = __webpack_public_path__ + "static/media/report.c0bd4fee.svg";